<template>
        <!-- <Transition name="slide" appear> -->
        <div class="offcanvas_body" :ref="modalContentRef"
            :class="size==='small' ? 'canvasSmall' : size==='xlarge' ? 'canvasXLarge' : size==='large' ? 'canvasLarge' : size==='xsmall' ? 'canvasExtraSmall' : ''"
        >
            <slot></slot>
        </div>
        <!-- </Transition> -->
</template>

<script setup>
import {ref} from 'vue'
import { useModalContent } from '@/composables/useModalContent.js';
const offcanvas_body = ref();
import { Transition } from "vue";
const props = defineProps({
    size:{
        type:String,
        default:'',
    }
});
const { modalContentRef } = useModalContent();
defineExpose({
    offcanvas_body
})
</script>

<style scoped>
.offcanvas_body {
    @apply max-w-full absolute top-0 right-0 bottom-0 bg-white shadow-xl dark:shadow-black-900 dark:bg-dark-100 overflow-y-auto transition-all z-50;
}
.canvasSmall{
    @apply !max-w-[40.5625rem] !w-full !overflow-visible !rounded-l-lg;
}
.canvasLarge{
    @apply xl:!max-w-[78.1875rem] !max-w-[61.1875rem] !w-full !overflow-visible !rounded-l-lg;
}
.canvasXLarge{
    @apply md:!max-w-[calc(100%-88px)] !w-full lg:!overflow-visible overflow-auto !rounded-l-lg;
}
.canvasExtraSmall{
    @apply !max-w-[25rem] !w-full !overflow-visible !rounded-l-lg;
}

/* @keyframes slide {
    0% {
        opacity: 0;
        transform: translateX(100%);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

.slide-enter-active {
    animation: slide 0.5s;
}

.slide-leave-active {
    animation: slide 0.5s reverse;
} */
</style>
